/**
 * IconButton — Botão redondo com ícone (SVG ou emoji)
 */
import { ComponentChildren } from 'preact';
import { T } from '../../styles/tokens';

interface IconButtonProps {
  icon: ComponentChildren;
  onClick?: (e: Event) => void;
  size?: number;
  active?: boolean;
  variant?: 'default' | 'danger' | 'primary';
  disabled?: boolean;
  title?: string;
  style?: any;
}

const variantStyles: Record<string, any> = {
  default: {
    background: 'transparent',
    border: `1px solid ${T.bgHover}`,
    color: T.textSecondary,
  },
  danger: {
    background: T.dangerBg,
    border: `1px solid ${T.dangerBg}`,
    color: T.danger,
  },
  primary: {
    background: T.primaryBg,
    border: `1px solid ${T.primaryBg}`,
    color: T.primary,
  },
};

export function IconButton({
  icon, onClick, size = 38, active, variant = 'default',
  disabled, title, style: extraStyle,
}: IconButtonProps) {
  const vs = variantStyles[variant] || variantStyles.default;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={title}
      style={{
        width: size, height: size, borderRadius: '50%',
        ...vs,
        ...(active ? { background: T.primaryBg, borderColor: T.primary } : {}),
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'all 0.2s',
        padding: 0,
        ...extraStyle,
      }}
    >
      {icon}
    </button>
  );
}
